import { FC, ReactNode } from 'react';
import { DisabledForm } from '../common/DisabledForm';

interface NoWalletProps {
  wallet: ReactNode;
}

export const NoWallet: FC<NoWalletProps> = ({ wallet }) => {
  return (
    <DisabledForm
      heading="Wallet is not connected."
      paragraph="Please connect a wallet in order to start operating."
      cta={wallet}
    />
  );
};
